import React from 'react';
import HomePage from '../homepage/homepage';
import Contact from '../contactus/contact';
import Footer from '../footer/footer';
import AboutArtist from '../about-artist/aboutartist';

function HomeScreen() {
  return (
    <div>
      {/* <Navbar /> */}
      {/* <Hero /> */}
      <HomePage />
      {/* <Services />
      <Pricing /> */}
      <AboutArtist />
      <Contact />
      {/* <Footer /> */}
    </div>
  );
}

export default HomeScreen;
